@if (visibleMessages()?.length > 0) {
	<div class="system-banner-container">
		@for (message of visibleMessages(); track message.SystemBannerId) {
			<div class="system-banner-row" [class]="getBannerClasses(message)">
				<div class="system-banner-body">
					@if (message?.Title) {
						<span class="block font-bold whitespace-pre-line">{{ message.Title }}</span>
					}
					@if (message?.Message) {
						<span class="whitespace-pre-line">{{ message.Message }}</span>
					}
					@if (message.Url) {
						<a class="system-banner-link" [href]="message.Url" target="_blank" rel="noopener noreferrer"> See More </a>
					}
				</div>

				<p-button
					(click)="dismiss(message)"
					type="button"
					pTooltip="Dismiss"
					[text]="true"
					[rounded]="true"
					[plain]="true"
					icon="pi pi-times"
					data-testid="systemBannerDismiss"
					styleClass="system-banner-dismiss-button" />
			</div>
		}
	</div>
}
